import React from 'react'
import ProgressUI from '../../widgets/output/ProgressUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import LabelAndValueUI from '../../widgets/layout/LabelAndValueUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import VendorBillListUI from '../../components/finapp/vendorBill/VendorBillListUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import InvoiceCreateModalSF from '../../components/finapp/invoice/InvoiceCreateModalSF'
import './VendorBillListPage.css'

const VendorBillListPageUI = ({ context, messageList, errorList, billList, filteredBillList,
  searchFilter, onRefreshClick, onSearchFilterChange,
  onCreateBillClick, createBillMode, onCancelCreateBill, onCreateBillComplete
}) =>
  <PrivatePageSF context={context} className='pg_vnd_bls' backLink='/home'
    messageList={messageList} headerText='Vendor bills'
    centered={!billList && !errorList}
  >
    {
      !billList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      billList &&
      <PageTitleUI context={context} goBack={true} backLink='/home' messageList={messageList} titleText='Vendor bills' />
    }
    {
      billList && billList.length === 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        onCreateClick={onCreateBillClick}
        createLinkKey='c_create_invoice'
        createDisabledMessageKey='c_no_invoice_msg'
      />
    }
    {
      billList && filteredBillList && billList.length !== 0 &&
      <VendorBillListUI
        context={context}
        billList={filteredBillList}
        messageList={messageList}
        searchFilter={searchFilter}
        // events
        onCreateClick={onCreateBillClick}
        onRefreshClick={onRefreshClick}
        onSearchFilterChange={onSearchFilterChange}
      />
    }
    <InvoiceCreateModalSF context={context} createMode={createBillMode}
      onCancelClick={onCancelCreateBill} onCreateComplete={onCreateBillComplete}
    />
  </PrivatePageSF>

export default VendorBillListPageUI
